import { createContext, useContext } from "react";

const MockDataContext = createContext(null);

const MockDataProvider = ({ value, children }) => (
  <MockDataContext.Provider value={value || {}}>
    {children}
  </MockDataContext.Provider>
);

const useMockData = () => {
  const value = useContext(MockDataContext);
  if (value === null) {
    throw new Error("useMockData must be called inside <MockDataProvider>");
  }
  return value;
};

export { MockDataProvider, useMockData };
